// plugins/responseInterceptor.js
import { Dialog } from 'vant'; // 根据你的UI库选择合适的弹窗组件

// 需要拦截的状态码列表
const CODE_LIST = [80039, 80095];

export default {
  install(Vue, options) {
    // 注册全局拦截方法
    Vue.prototype.$interceptCode = (response) => {
      const { code,message } = response;
      console.log('拦截响应数据:', response);
    //   let isDialogOpen = false;
      // 检查状态码是否在拦截列表中
      if (CODE_LIST.includes(code)) {
        console.log(`拦截状态码: ${code}，消息: ${message}`);
        // 避免重复弹窗
        // if (isDialogOpen) return response;
        
        // 显示弹窗（使用 setTimeout 确保异步，不阻塞请求链）
        // setTimeout(() => {
        //   showDialog(code,message);
        // }, 0);
        // 返回一个包含拦截状态的对象
        return {
            intercepted: true,
            response,
            handle: () => showDialog(code,message) // 返回处理函数，而不是立即执行
        };
      }
      
      // 未被拦截，正常返回响应
      return {
        intercepted: false,
        response
      };
    };
    // 显示弹窗的方法
    async function showDialog(code,message) {
        // isDialogOpen = true;
        try {
          console.log(`显示弹窗，状态码: ${code}，消息: ${message}`);
          // 使用 Vue.prototype.$dialog（需提前挂载 UI 组件）
          await Vue.prototype.$dialog.confirm({
            title: '提示',
            message: message || '发生了一个错误，请稍后再试。',
            confirmButtonText: '确认',
            cancelButtonText: '取消',
          });
          
          // 用户点击确认
          return Promise.reject({ intercepted: true, code: error.code });
        } catch (error) {
          // 用户点击取消
          return Promise.reject(error);
        } 
      }
  }
};